import { isValidToken } from '@/providers/authProvider';
import { TOKEN_KEY, TOKEN_WITHOUT_ROLES_KEY } from '@/utils/CONST';

const useGetTokenFromLocalStorage = () => () => {
    const autoAuthToken = localStorage.getItem(TOKEN_WITHOUT_ROLES_KEY);
    const normalToken = localStorage.getItem(TOKEN_KEY);

    if (autoAuthToken !== null && isValidToken(autoAuthToken)) return autoAuthToken;
    if (normalToken !== null && isValidToken(normalToken)) return normalToken;

    return undefined;
};

export default useGetTokenFromLocalStorage;
